import { useWidgetPostMessages } from '@widgets/messenger/utils/postMessages'

const useTabActivityMessages = (widgetId: string) =>
  useWidgetPostMessages<boolean>(widgetId, 'textmagicMessengerTabActivity')

export const subscribeOnMessengerTabActivity = (callback: (payload: boolean) => void) => {
  document.addEventListener('visibilitychange', () => {
    callback(document.visibilityState === 'visible')
  })
}

export const sendMessengerTabActivityMessage = (widgetId: string, iframe: HTMLIFrameElement, isActive: boolean) => {
  useTabActivityMessages(widgetId).sendToIframe(iframe, isActive)
}

export const subscribeOnMessengerTabActivityMessages = (widgetId: string, callback: (payload: boolean) => void) => {
  return useTabActivityMessages(widgetId).subscribe((event) => {
    callback(event.data.payload)
  })
}
